<style lang="less" scoped>
.main {
  width: 1240px;
  margin: 0 auto;
  margin-top: 30px;
  border-radius: 12px;
  position: relative;
  .load {
    position: absolute;
    top: 45%;
    left: 50%;
    transform: translate(50%, 50%);
    z-index: 99;
  }
  .top {
    min-height: 500px;
    display: flex;
    .left {
      flex: 20;
      background: #fff;
      border-radius: 12px;
      min-height: 450px;
      .content {
        width: 100%;
        height: 100%;
        padding: 0 50px;
      }
    }
    .right {
      flex: 4;
      margin-left: 20px;
      .order {
        height: 160px;
        background: #fff;
        border-radius: 12px;
        .studentLook {
          flex: 4;
          height: 160px;
          background: #fff;
          margin-left: 30px;
          border-radius: 12px;
          text-align: center;
          .orderMes {
            width: 120px;
            height: 40px;
            border-radius: 8px;
            background-image: linear-gradient(122deg, #ff8d46 0%, #fa5542 100%);
            margin-top: 20px;
            margin-left: -30px;
          }
          .studentView {
            width: 120px;
            height: 40px;
            border-radius: 8px;
            margin-top: 20px;
            margin-left: -30px;
            background: #f8f8f8;
            color: #000;
            border: none;
            .logo {
              width: 20px;
              height: 20px;
              margin-top: -4px;
              margin-right: 8px;
              margin-left: -10px;
            }
          }
        }
      }
    }
  }
  .dialog {
    background-color: white;
    border-radius: @border-radius-base;
    margin: 0 50px;
  }
  .dialog-content-title {
    font-family: "STSongti-SC-Black";
    font-size: 22px;
    font-weight: bolder;
    height: 95px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .dialog-content-title-i {
    font-family: "STSongti-SC-Black";
    font-weight: bolder;
    font-size: 18px;
    height: 44px;
    color: #5a99ef;
    background-color: #eef4fd;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .dialog-content-ii {
    padding: 30px 50px;
    font-family: "STSongti-SC-Black";
    font-size: 18px;
    background-color: @white;
  }
  .dialog-content-ii p {
    text-indent: 2em;
    line-height: 2em;
  }
  .open {
    width: 44px;
    height: 44px;
    cursor: pointer;
  }
}
</style>
<template>
  <div class="main">
    <a-spin class="load"
            v-show="loading" />
    <div class="top">
      <div class="left"
           v-if="unitGuideData">
        <div class="dialog">
          <div class="dialog-content-title">
            <span>{{unitGuideData&&unitGuideData.unitTitle}}</span>
          </div>
          <div class="dialog-content-title-i">

            <span>{{unitGuideData&&unitGuideData.title}}</span>
          </div>

        </div>
        <div class="dialog-content-ii">
          <p>{{unitGuideData&&unitGuideData.unitIntroductionContent}}</p>
        </div>

        <div class="dialog-content-title-i">
          <span>{{unitGuideData&&unitGuideData.subjectTitle}}</span>
        </div>

        <div class="dialog-content-ii">
          <div v-for="(item,index) in unitGuideData&&unitGuideData.subjectContents"
               :key="index">
            <h4 v-if="item.format===1"><b>{{item.content}}</b></h4>
            <p v-if="item.format===0">
              <img src="@/assets/imgs/logo.png"
                   style="width:10px;height:10px" />
              {{item.content}}
            </p>
          </div>
        </div>
        <div class="dialog-content-title-i">
          <span>{{unitGuideData&&unitGuideData.studyGoalTitle}}</span>
        </div>
        <div class="dialog-content-ii">
          <div style="text-align: center"
               v-if="unitGuideData&&unitGuideData.studyGoalContentS && unitGuideData.studyGoalContentS.length>1">
            <a-radio-group v-model="studyGoalContentIndex"
                           button-style="solid">
              <a-radio-button style="padding:0 30px"
                              :value="index"
                              v-for="(item,index) in unitGuideData&&unitGuideData.studyGoalContentS"
                              :key="index">
                {{item.title}}
              </a-radio-button>
            </a-radio-group>
          </div>
          <div v-show="studyGoalContentIndex===index"
               v-for="(item, index) in unitGuideData&&unitGuideData.studyGoalContentS"
               :key="index"
               style="white-space: pre-line">
            <h4 class="tabTitle">{{item.languageGoalTitle}}</h4>
            <div>{{item.languageGoalContent}}</div>
            <h4 class="tabTitle">{{item.thinkingGoalTitle}}</h4>
            <div>{{item.thinkingGoalContent}}</div>
            <h4 class="tabTitle">{{item.valueGoalTitle}}</h4>
            <div>{{item.valueGoalContent}}</div>
          </div>
        </div>
      </div>
      <div class="empty"
           style="margin:200px auto"
           v-else>
        <a-empty />
      </div>
    </div>
    <!-- <div class="right">
            <div class="order">
                <div class="studentLook">
                    <a-button class="orderMes" type="primary">发布</a-button>
                    <a-button class="studentView" type="primary"><img class="logo" src="@/assets/imgs/logo2.png" />学生端预览</a-button>
                </div>
            </div>
        </div> -->
  </div>
  <!-- </div> -->
</template>

<script>
// import HanIcon from 'components/Icon.vue'
import axios from 'axios'
export default {
  name: 'ZhunBei',
  components: {

  },
  created () {

  },
  data () {
    return {
      unitGuideData: {},
      microLessonDate: {},
      studyGoalContentIndex: 0,
      loading: true
    }
  },
  watch: {
    mlVisible () {

    }
  },
  mounted () {
    this.getData()
  },
  methods: {
    getData () {
      this.studyGoalContentIndex = 0
      // this.$fetch({
      //     url: this.$baseUrl + 'ebook/unit/getUnitGuidance',
      //     body: {
      //         styleId: localStorage.getItem('styleId'),
      //         userId :'ef55937ea0434b21ae5c8af250e816f1',
      //         classId: '933'
      //     }
      //     }).done(res => {
      //
      //     this.unitGuideData = res.resultData
      //     // console.log(this.unitGuideData)
      //     this.visible = true
      // })

      this.$fetch({
        url: this.$baseUrl + 'ebook/teacher/unit/getUnitGuidance',
        body: {
          styleId: localStorage.getItem('styleId')
        }
      }).done(res => {
        if (res && res.success && res.resultCode == 0) {
          this.loading = false
          this.unitGuideData = res.resultData
        }
      })
    }
  }
}
</script>

